import Constants, { getTechnologyGridNavigationPath } from '../../../app/utils/constants'
import AnimationButton from '../../atoms/AnimationButton/AnimationButton'
import technologybgg from '../../../assets/images/homepage/technologybgg.webp'
import arrowicon from '../../../assets/images/icons/arrowicon.svg'
import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'

const Technology = () => {
  const {
    FullSpectrumTechnologyServices,
    frontendServices,
    backendCards,
    databaseIcons,
    cloudDevopsItems,
    automationItems,
  } = Constants

  const navigate = useNavigate()

  // ✅ FIXED: matched to actual title in FullSpectrumTechnologyServices
  const DEFAULT_SERVICE = 'Frontend Development'
  const [activeService, setActiveService] = useState<string>(DEFAULT_SERVICE)
  const [hoveredService, setHoveredService] = useState<string | null>(null)

  const getIconsForService = (serviceTitle: string) => {
    switch (serviceTitle) {
      // ✅ FIXED: was 'Web Development', now matches actual title
      case 'Frontend Development':
        return frontendServices.slice(0, 6).map((item: { icon: string }) => item.icon)

      case 'AI & Automation':
        return [
          automationItems[2]?.icon,
          automationItems[1]?.icon,
          automationItems[2]?.icon,
          automationItems[1]?.icon,
          automationItems[0]?.icon,
          automationItems[0]?.icon,
        ].filter(Boolean) as string[]

      case 'Backend Development':
        return backendCards.slice(0, 6).map((item: { icon: string }) => item.icon)

      case 'Database':
        return [
          databaseIcons[0]?.icon,
          databaseIcons[1]?.icon,
          databaseIcons[0]?.icon,
          databaseIcons[1]?.icon,
          databaseIcons[3]?.icon,
          databaseIcons[2]?.icon,
        ].filter(Boolean) as string[]

      case 'Cloud & devops':
        return cloudDevopsItems.slice(0, 6).map((item: { icon: string }) => item.icon)

      default:
        return frontendServices.slice(0, 6).map((item: { icon: string }) => item.icon)
    }
  }

  const orbitIcons = getIconsForService(activeService)

  const orbitPositions = [
    'left-[20%] top-[2%] -translate-x-1/2 -translate-y-1/2',
    '-right-7 top-1/2 translate-x-1/2 -translate-y-1/2',
    'left-[80%] bottom-[0%] -translate-x-1/2 translate-y-1/2',
    '-left-7 top-1/2 -translate-x-1/2 -translate-y-1/2',
    'right-[20%] top-[0%] translate-x-1/2 -translate-y-1/2',
    'left-[20%] bottom-[2%] -translate-x-1/2 translate-y-1/2',
  ]

  return (
    <div className="
    w-full
    flex flex-col sm:flex-row
    items-center justify-between
    px-4 sm:px-6 md:px-10 lg:px-14 xl:px-20 2xl:px-28
    py-6 sm:py-8 md:py-10 lg:py-10 xl:py-0
    h-auto sm:h-[340px] md:h-[400px] lg:h-[550px] xl:h-[600px] 2xl:h-[860px]
    gap-6 sm:gap-4 md:gap-8 lg:gap-8 xl:gap-12 2xl:gap-16
    overflow-hidden
  ">

      {/* LEFT */}
      <div className="
  relative flex items-center justify-center shrink-0
  w-full sm:w-[40%] md:w-[42%] lg:w-[44%] xl:w-[44%] 2xl:w-[45%]
  h-[220px] sm:h-full
">
        <img
          src={technologybgg}
          alt="Technology"
          className="h-[99%] md:-[85%] w-auto object-contain relative"
        />

<div className="pointer-events-none absolute inset-0 flex items-center justify-center">

  {/* CENTER + ORBIT CONTAINER */}
  <div className="relative flex items-center justify-center">

    {/* CENTER DASHED RING */}
    <div
      className="
        absolute
        rounded-full
        border-[1.5px]
        sm:border-2
        border-dashed
        border-[rgba(234,77,237,1)]

        animate-[spin_30s_linear_infinite]

        w-15 h-15
        sm:w-20 sm:h-20
        md:w-18 md:h-18
        lg:w-26 lg:h-26
        xl:w-34 xl:h-34
        2xl:w-50 2xl:h-50
      "
    />

    {/* ICON ORBIT */}
    <div className="relative animate-[spin_30s_linear_infinite]">

      {orbitIcons.map((icon, i) => {
        const total = orbitIcons.length
        const angle = (2 * Math.PI * i) / total

        const ringRadius = 34
        const iconSize = 32
        
        const gap =
  window.innerWidth >= 1536
    ? 180 // 2xl
    : window.innerWidth >= 1280
      ? 140 // xl
      : window.innerWidth >= 1024
        ? 90 // lg
        : window.innerWidth >= 768
          ? 60 // md
          : window.innerWidth >= 640
            ? 20 // sm
            : 20 // mobile

const radius = ringRadius + gap + iconSize / 2
        
        const x = Math.cos(angle) * radius
        const y = Math.sin(angle) * radius

        return (
          <div
            key={i}
            className="
              absolute
              left-1/2
              top-1/2
            "
            style={{
              transform: `
                translate(${x}px, ${y}px)
                translate(-50%, -50%)
              `,
            }}
          >
            {/* ICON STAYS STRAIGHT */}
            <div className="animate-[spin_30s_linear_infinite_reverse]">

              <div
                className="
                  relative
                  flex
                  items-center
                  justify-center
                  rounded-full
                  bg-[#0D0823]

                  w-8 h-8
                  sm:w-10 sm:h-10
                  lg:w-14 lg:h-14
                  xl:w-17 xl:h-17
                  2xl:w-25 2xl:h-25
                "
              >
                {/* BORDER */}
                <span
                  className="absolute inset-0 rounded-full"
                  style={{
                    padding: '1.5px',
                    background:
                      'linear-gradient(138.94deg,#EA4DED 0%,rgba(234,77,237,0) 50%,#EA4DED 100%)',
                    WebkitMask:
                      'linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0)',
                    WebkitMaskComposite: 'xor',
                    mask:
                      'linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0)',
                    maskComposite: 'exclude',
                  }}
                />

                <img
                  src={icon}
                  alt=""
                  className="
                    relative
                    z-10
                    w-[55%]
                    h-[55%]
                    object-contain
                  "
                />
              </div>

            </div>
          </div>
        )
      })}

    </div>

  </div>

</div>
      </div>

      {/* RIGHT */}
      <div className="
  flex flex-col justify-center
  items-start sm:items-start
  text-left sm:text-left
  gap-2 sm:gap-3 md:gap-5 lg:gap-7 xl:gap-9 2xl:gap-11
  w-full sm:w-[57%] md:w-[55%] lg:w-[53%] xl:w-[53%] 2xl:w-[52%]
  h-full
">

        <h1 className="
          text-white font-rajdhani font-semibold leading-tight
          text-sm sm:text-xl md:text-2xl lg:text-[30px] xl:text-[37px] 2xl:text-[47px]
          w-[55%] md:w-[90%] lg:w-[65%] xl:w-[55%] 2xl:w-[70%]
        ">
          Full-Spectrum Technology Services
        </h1>

        <div className="w-full grid grid-cols-2 gap-3 sm:gap-2 md:gap-3 lg:gap-3 xl:gap-4 2xl:gap-5">
          {FullSpectrumTechnologyServices.map((item, i) => (
            <div
              key={i}
              className="p-px font-rajdhani font-semibold rounded-full bg-[linear-gradient(168.94deg,#745EF0_0%,rgba(116,94,240,0.1)_50%,#745EF0_100%)]"
            >
              <AnimationButton
                onClick={() => {
                  const path = getTechnologyGridNavigationPath(item.title)
                  if (path) navigate(path)
                }}
                onMouseEnter={() => {
                  setHoveredService(item.title)
                  setActiveService(item.title)
                }}
                onMouseLeave={() => {
                  setHoveredService(null)
                  setActiveService(DEFAULT_SERVICE)
                }}
                onFocus={() => {
                  setHoveredService(item.title)
                  setActiveService(item.title)
                }}
                onBlur={() => {
                  setHoveredService(null)
                  setActiveService(DEFAULT_SERVICE)
                }}
                className={`
                  transition-all duration-500 ease-in
                  ${
                    (hoveredService === null && item.title === DEFAULT_SERVICE) || hoveredService === item.title
                      ? 'bg-[#745ef0] scale-105'
                      : 'bg-[#0b0636d5]'
                  }
                  text-[10px] md:text-xs lg:text-base xl:text-lg 2xl:text-2xl
                  px-1 py-1
                  sm:px-3 sm:py-1.5
                  md:px-0 md:py-0
                  lg:px-4 lg:py-2.5
                  xl:px-5 xl:py-3   
                  2xl:px-6 2xl:py-4
                `}
              >
                {item.title}
              </AnimationButton>
            </div>
          ))}
        </div>

    
  <style>
    {`
      /* UNDERLINE */
      .link-underline::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -4px;
        width: 0%;
        height: 2px;
        background: #744DFF;
        transition: width 0.4s ease;
      }

      .group:hover .link-underline::after {
        width: 100%;
      }

      @keyframes arrowIdle {
        0% {
          transform: translateX(0);
        }
        50% {
          transform: translateX(6px);
        }
        100% {
          transform: translateX(0);
        }
      }

      /* 🔥 HOVER EXIT ANIMATION */
      @keyframes arrowExit {
        0% {
          transform: translateX(0);
          opacity: 1;
        }
        70% {
          transform: translateX(10px);
          opacity: 1;
        }
        100% {
          transform: translateX(100px);
          opacity: 0;
        }
      }

      /* APPLY HOVER ANIMATION (OVERRIDES IDLE) */
      .group:hover .arrow-wrapper {
        animation: arrowExit 0.5s ease forwards;
        animation-delay: 0.4s;
      }
    `}
  </style>

        {/* LINK */}
        <Link
    to="/technology"
    className="group mt-2 inline-flex max-w-full items-center gap-2 self-start sm:mt-3 md:mt-4 lg:mt-5"
  >
    {/* TEXT */}
    <span className="link-underline relative font-gilroy-medium text-[10px] text-white sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl">
      View all our Technology Services
    </span>

    {/* ICON */}
    <span className="arrow-wrapper inline-flex animate-[arrowIdle_1s_ease-in_infinite]">
      
      {/* INNER ICON (rotation stays unaffected) */}
      <span
        className="inline-block h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 lg:h-7 lg:w-7 xl:h-8 xl:w-8 2xl:h-9 2xl:w-9 rotate-45 bg-purple mask-contain mask-no-repeat mask-center"
        style={{
          maskImage: `url(${arrowicon})`,
          WebkitMaskImage: `url(${arrowicon})`,
        }}
      />
    </span>
  </Link>

      </div>
    </div>
  )
}

export default Technology